import SchemaPropTypes from '@get-bridge/learn-legacy-shared/dist/shared/SchemaPropTypes';
const { shape, string } = SchemaPropTypes;

export default shape({
  qrCode: string,
  shareable: string,
});



// WEBPACK FOOTER //
// ./packages/bridge-global-nav/src/mobile_app_links/LinksPayload.js